<div class="ip-title-mobile">
  <div class="ip-title-mobile__title">
    <mat-icon class="ip-title-mobile__title-back-icon" *ngIf="back" (click)="goBack()">arrow_back</mat-icon>    
    {{ title }}
  </div>
  <!-- <app-ip-button-modal
    [typeBtn]="'submit'"
    *ngIf="btn === 'create'"
    (clicked)="onClickButton($event)"
    [size]="'large'"
    >  
    <mat-icon class="ip-title-mobile__btn-icon">add</mat-icon> 
    <span *ngIf="mobile">{{ "IP.COMMON.BUTTON-CREATE" | translate }}</span> 
    <span *ngIf="!mobile">{{ btnText ?? ("IP.COMMON.BUTTON-CREATE" | translate) }}</span> 
  </app-ip-button-modal> -->
  <button 
    class="ip-title-mobile__btn" 
    *ngIf="btn === 'create' && !onlyRead"
    (click)="onClickButton($event)">
    <mat-icon class="ip-title-mobile__btn-icon">add</mat-icon> 
    <span *ngIf="mobile">{{ "IP.COMMON.BUTTON-CREATE" | translate }}</span> 
    <span *ngIf="!mobile">{{ btnText ?? ("IP.COMMON.BUTTON-CREATE" | translate) }}</span> 
  </button>
  <button 
    class="ip-title-mobile__btn" 
    *ngIf="btn === 'filter' && mobile"
    (click)="onClickButton($event)">
    <mat-icon class="ip-title-mobile__btn-icon">search</mat-icon> 
    <span>{{ "IP.FILTERS_MODAL.FILTER" | translate }}</span> 
  </button> 
  <button 
    class="ip-title-mobile__btn" 
    *ngIf="btn === 'other' && !onlyRead"
    (click)="onClickButton($event)">
    <span>{{ btnText ?? ("IP.COMMON.BUTTON-CREATE" | translate) }}</span> 
  </button> 
  <ng-content></ng-content>
</div>
<div class="ip-title-mobile-sm" *ngIf="mobile"></div>